import React from 'react';
import { useParams } from 'react-router-dom';
import VolunteerManagement from 'components/admin/volunteer/VolunteerManagement';

const Volunteer = () => {
  const { clubId, meetId } = useParams();

  return <VolunteerManagement clubId={clubId} meetId={meetId} />;
};

export default Volunteer;
